<script lang="ts" setup>
import type { IProps } from './AnalyticsCards.types'
import { useParsedAnalysts } from '@/composables/useParsedAnalysts'

const props = defineProps<IProps>()

const parsedAnalysts = useParsedAnalysts(props.table?.table)
</script>

<template>
  <div class="analytics-cards">
    <div class="analytics-cards__container">
      <h2 class="analytics-cards__title">
        {{ table.title }}
      </h2>

      <div class="analytics-cards__cards">
        <div
          v-for="(contact, index) in parsedAnalysts"
          :key="`analytics-card-${index}`"
          class="analytics-cards__card"
        >
          <h3 class="analytics-cards__card-title">
            {{ contact.institution }}
          </h3>

          <p class="analytics-cards__card-analyst">
            {{ contact.analyst }}
          </p>
          
          <a
            v-if="contact.email"
            :href="`mailto:${contact.email}`"
            class="analytics-cards__card-email"
          >
            {{ contact.email }}
          </a>

          <p
            v-if="contact.phone"
            class="analytics-cards__card-phone"
          >
            tel.: {{ contact.phone }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.analytics-cards {
  @include section-investor();
  display: grid;

  &__container {
    @include section-investor__container();
  }

  &__title {
    @include h5;
    color: $text-400;
    text-align: center;
  }

  &__cards {
    display: grid;
    gap: 1.2rem;
    margin-top: 3.2rem;
  }

  &__card {
    padding: 1.6rem 2.4rem;
    background: $white;
    border: 1px solid $neutral-300;
    border-radius: 1.2rem;
  }

  &__card-title {
    @include body-3-medium;
    margin-bottom: 0.4rem;
    color: $text-400;
  }

  &__card-analyst {
    @include body-3;
    margin-bottom: 1rem;
    color: $text-400;
  }

  &__card-email {
    @include body-3;
    margin-bottom: 0.4rem;
    color: #2C5EC5;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &__card-phone {
    @include body-3;
    color: $text-400;
  }
}
</style>
